import { PantaFormStepPassedProps } from "@sharedComponents/PantaForm/types";

export interface Step2Props extends PantaFormStepPassedProps {
    cmsContent?: any
    formValues?: any
    setFormValues?: any
    rehydrateFormKey: boolean
    newRegistration?: Function
}

export enum NumberType {
    Organisation = 'org',
    Vat = 'vat',
}